import { render, staticRenderFns } from "./ComixMusicPlayer.vue?vue&type=template&id=78bc185f&"
import script from "./ComixMusicPlayer.vue?vue&type=script&lang=js&"
export * from "./ComixMusicPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports